export enum ParserApiRoutes {
  parse = "/api/v1/autofill/parse",
}

export interface ParserProjectUrlGenerator {
  parse(): string;
}

export class ParserUrlGenerator implements ParserProjectUrlGenerator {
  parse(): string {
    return ParserApiRoutes.parse;
  }
}
